module.exports = __webpack_public_path__ + "static/biko-5540f62e0d0f5d725efeb939651d9f2a.jpg";